import Joi from "joi";

export default Joi.object({
	key_id: Joi.string().required(),
	key_secret: Joi.string().required()
});
